import createReducer from '../utils/createReducer';
import {
  APP_CONFIG_REQUEST,
  APP_CONFIG_FAILURE,
  APP_CONFIG_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: {},
};

export default createReducer(initialState, {
  [APP_CONFIG_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [APP_CONFIG_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data,
    })
  ),
  [APP_CONFIG_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/appConfig.js